export default "__VITE_ASSET__D83__pks__"